import { getTransferFilterModel } from '@/explore/ducks/selectors';
import { Button, Divider, FormControl, Input, InputGroup, InputRightElement, Image } from '@chakra-ui/react';
import { FormEvent, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setTransferFilterModel, setTransferSearchText } from '../ducks/slice';
import { getTransferSearchText } from '../ducks/selectors';
import FFLRecognizer from '@/utils/regexMatcher';
import { useSearchParams } from 'react-router-dom';

function TransferSearchForm() {
  const dispatch = useDispatch();
  const transferFilterModel = getTransferFilterModel();
  const transferSearchText = getTransferSearchText();
  const isFirstLoad = useRef(true);
  const [isValueUpdated, setIsValueUpdated] = useState<boolean>(false);
  const [searchParams, setURLSearchParams] = useSearchParams();

  useEffect(() => {
    if(isFirstLoad.current) {
      isFirstLoad.current = false;
      // Check to find valid regex match for 8 or 16 digit id
      const recognizer = new FFLRecognizer();
      const match = recognizer.matches(transferSearchText.trim());
      const value =
        match && match.length > 3
          ? `${match[1]}${match[2]}${match[3]}`
          : transferSearchText.trim();
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          searchText: {
            ...transferFilterModel.referenceId,
            filter: value
          }
        })
      );
    }
  }, []);

  useEffect(() => {
    const dealerId = searchParams.get('dealer_id');
    if (dealerId) {
      setIsValueUpdated(true)
      setTimeout(() => {
        dispatch(
          setTransferFilterModel({
            ...transferFilterModel,
            searchText: {
              ...transferFilterModel.searchText,
              filter: dealerId
            }
          })
        );
        dispatch(setTransferSearchText(dealerId));
      }, 1500);
    }
  }, [searchParams])

  // Event Handlers
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsValueUpdated(true)
    dispatch(setTransferSearchText(event.target.value));
  };

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    try {
      // Check to find valid regex match for 8 or 16 digit id
      const recognizer = new FFLRecognizer();
      const match = recognizer.matches(transferSearchText.trim());
      const value =
        match && match.length > 3
          ? `${match[1]}${match[2]}${match[3]}`
          : transferSearchText.trim();

      if (transferFilterModel && transferFilterModel.referenceId) {
        dispatch(
          setTransferFilterModel({
            ...transferFilterModel,
            searchText: {
              ...transferFilterModel.referenceId,
              filter: value
            }
          })
        );
      }
    } catch (error) {
      console.error('Failed to process the search:', error);
    }
  };

  return (
    <form onSubmit={onSubmit}>
        <FormControl whiteSpace={'nowrap'} padding={0}>
        <InputGroup className="input-group">
            <Input
              value={isValueUpdated ? transferSearchText : transferFilterModel?.searchText?.filter }
              autoFocus
              placeholder={'Search...'}
              onChange={onChangeHandler}
              height={'40px'}
            />
            <InputRightElement
              width="4.5rem"
              className="input-right-element"
              alignItems={'center'}
            >
            <Divider
                orientation="vertical"
                className="input-right-divider"
            />
            <Button type={'submit'} size={'sm'} backgroundColor={'#FFFFFF'}>
                <Image src="/images/ui/searchIcon.svg"></Image>
            </Button>
            </InputRightElement>
        </InputGroup>
        </FormControl>
    </form>
  )
}

export default TransferSearchForm;
